import React, { createContext, useContext, useState, useEffect } from 'react'

const PatientContext = createContext()

export const usePatient = () => {
    const context = useContext(PatientContext)
    if (!context) {
        throw new Error('usePatient must be used within a PatientProvider')
    }
    return context
}

export const PatientProvider = ({ children }) => {
    const [selectedPatient, setSelectedPatient] = useState(null)
    const [patients, setPatients] = useState([])
    const [loading, setLoading] = useState(false)

    // Load patients from localStorage on mount
    useEffect(() => {
        const savedPatient = localStorage.getItem('selectedPatient')
        if (savedPatient) {
            try {
                setSelectedPatient(JSON.parse(savedPatient))
            } catch (error) {
                console.error('Error parsing saved patient:', error)
                localStorage.removeItem('selectedPatient')
            }
        }
    }, [])

    // Save selected patient to localStorage when it changes
    useEffect(() => {
        if (selectedPatient) {
            localStorage.setItem('selectedPatient', JSON.stringify(selectedPatient))
        } else {
            localStorage.removeItem('selectedPatient')
        }
    }, [selectedPatient])

    const updateSelectedPatient = (patient) => {
        setSelectedPatient(patient)
    }

    const clearSelectedPatient = () => {
        setSelectedPatient(null)
    }

    const value = {
        selectedPatient,
        patients,
        setPatients,
        loading,
        setLoading,
        updateSelectedPatient,
        clearSelectedPatient,
    }

    return (
        <PatientContext.Provider value={value}>
            {children}
        </PatientContext.Provider>
    )
} 